import React from 'react';
import './ProfessionalSummary.scss';

const ProfessionalSummary = () => {
	return (
		<section className="professional-summary">
			<h2 className="professional-summary__title">Professional Summary</h2>
			<p className="professional-summary__content">
				Senior Software Engineer with 15+ years of experience specializing in high-performance,
				secure web applications. Expert in the modern stack, including JavaScript, React, Next.js,
				and AWS, leveraging CI/CD for streamlined delivery. Proven leader in Agile environments,
				dedicated to mentoring engineers, and driving initiatives in accessibility (A11Y),
				usability, and performance optimization.
			</p>
		</section>
	);
};

export default ProfessionalSummary;
